// removed by extract-text-webpack-plugin
module.exports = {"Auth":"_2YUr1vYMbwujw6K1HuakLc","SwitchAuth":"_2iT0zJ1VyG4mJ57ZHWXPfa","Error":"_1yGDyh2UbOJD3y0AN8KHcn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 238
// module chunks = 0